import React from "react"
import "./TogglePreview.css"
import { getTranslation } from "../../../assets/creator/translations"
import arrowRight from "../../../assets/creator/icons/arrows/arrow-right.svg"
import arrowLeft from "../../../assets/creator/icons/arrows/arrow-left.svg"
import questionMark from "../../../assets/creator/icons/arrows/question-mark.svg"
import arrowRightDisabled from "../../../assets/creator/icons/arrows/arrow-right-disabled.svg"
import arrowLeftDisabled from "../../../assets/creator/icons/arrows/arrow-left-disabled.svg"

const TogglePreview = props => (
	<div className='header-rightSide'>
		<div className='header-rightSide__container'>
			{props.disablePrev === false && (
				<button className='header-rightSide__container___btn arrowLeft' onClick={props.prevChange}>
					<img src={arrowLeft} alt={""}/>
				</button>
			)}
			{props.disablePrev !== false && (
				<button className='header-rightSide__container___btn arrowLeft disableArrow' onClick={null}>
					<img src={arrowLeftDisabled} alt={""}/>
				</button>
			)}

			{props.disableForward === false && (
				<button className='header-rightSide__container___btn arrowRight' onClick={props.forwardChange}>
					<img src={arrowRight} alt={""}/>
				</button>
			)}
			{props.disableForward !== false && (
				<button className='header-rightSide__container___btn arrowRight disableArrow' onClick={null}>
					<img src={arrowRightDisabled} alt={""}/>
				</button>
			)}

			<span className='borderLine borderLine_first'></span>
			<div className='header-rightSide__container___btn questionMark'>
				<img src={questionMark} alt={""}/>
				<span className='questionMark__Helper'></span>
				<ul className='ulActive'>
					<a href='https://pomoc.comarchesklep.pl/' target="_blank" rel="noopener noreferrer">
						<li>{getTranslation("HelpCenter")}</li>
					</a>
					<li onClick={props.openInstruction}>{getTranslation("GuideQuickStart")}</li>
				</ul>
			</div>
			<span className='borderLine borderLine_second' />
		</div>
		<div className='toggle-preview' onClick={props.onClick}>
			<span className='toggle-preview__text'>{getTranslation("Preview")}</span>
		</div>
	</div>
)

export default TogglePreview;
